(function () {

    var formApp = angular.module('formApp');

    // this controller is use executes the functionality in feedback landing page
    formApp.controller('landingController', ['$scope', '$rootScope', '$location', '$timeout', 'UtilityServices', 'DataServices', 'Constants',
        function ($scope, $rootScope, $location, $timeout, UtilityServices, DataServices, Constants) {

            // this sets the page title
            document.title = 'Feedback Management System';

            DataServices.incidentSubmitted = false;

            $scope.isLoading = false;
            $scope.utility = UtilityServices;
            
            $scope.department = Constants.Url.landing;
            

            // this gets and set the config data 
            var getConfigDataAndRedirect = function (templateId, destinationPath) {

                $scope.isLoading = true;
               
                
                setDefaultValues();
                DataServices.validationErrors = [];

                DataServices.getConfigurationUsingCache(templateId, null, null, DataServices.isAuthenticated())
                    .then(function (data) {
                        $location.path(destinationPath);
                    })
                    .finally(function () {
                        $scope.isLoading = false;
                    });

                $rootScope.allowFormNavigation = true;
            }

            $scope.createFeedback = function () {
                getConfigDataAndRedirect(Constants.ConfigTemplate.complaint, Constants.Url.firstComplaintFormPage);
            }

            var setDefaultValues = function () {
                DataServices.responseInfo.responses = {};
                DataServices.responseInfo.lastUpdatedTime = null;
                DataServices.responseInfo.incidentId = null;
                DataServices.responseInfo.incidentRef = null;
                DataServices.responseInfo.reportedDate = null;
                DataServices.responseInfo.status = null;
                DataServices.responseInfo.submittedDate = null;
            }
        }]);
}());